<template>
    <div class="content-wapper">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item>法律维权典型案例与分析</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6">
                <el-row class="left-img">
                    <img src="@/assets/images/xwqyczfw/flwq/flwq.jpg"/>
                </el-row>

                <el-row class="menu-box">
                    <div>
                        <div class="menu-level1"
                             @click="changeMenu('律师服务团工作规则','0101','')">律师服务团工作规则
                        </div>
                    </div>
                    <div>
                        <div class="menu-level1"
                             @click="changeMenu('律师服务团律师名单','0201','')">律师服务团律师名单
                        </div>
                    </div>
                    <div>
                        <div class="menu-level1"
                             @click="changeMenu('法律维权典型案例与分析','0301','')">法律维权典型案例与分析
                        </div>
                    </div>
                </el-row>
            </el-col>

            <el-col :span="18" class="right-box">
                <el-row class="right-box-row">
                    <!--法律服务团工作规则-->
                    <el-row v-show="flfwtgzgzOpen">
                        <!--标题-->
                        <el-row class="right-box-row-title">
                            {{title}}
                        </el-row>
                        <flfwtgzgz></flfwtgzgz>
                    </el-row>

                    <!--律师团名单-->
                    <el-row v-show="lstmdOpen">
                        <!--标题-->
                        <el-row class="right-box-row-title">
                            {{title}}
                        </el-row>
                        <!--表格-->
                        <el-table v-loading="lstmdLoading" :data="lstmdList"
                                  tooltip-effect="light" :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
                            <el-table-column label="姓名" align="left" prop="lawyer" width="110">
                                <template slot-scope="scope">
                                    <el-tag v-if="!isLoginState">登录后查看</el-tag>
                                    <span v-if="isLoginState" >{{scope.row.lawyer}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="律所名称" align="left" prop="lawOffice" 
							:show-tooltip-when-overflow="true" width="300"/>
                            <el-table-column label="管辖" align="center" prop="jurisdiction"/>
                            <el-table-column label="联系电话" align="left" prop="tel">
                                <template slot-scope="scope">
                                    <el-tag v-if="!isLoginState">登录后查看</el-tag>
                                    <span v-if="isLoginState" >{{scope.row.tel}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="业务专长" align="left" prop="specializedSill" :show-tooltip-when-overflow="true"/>
                        </el-table>
                        <!--下一页-->
                        <pagination
                                v-show="lstmdTotal>0"
                                :total="lstmdTotal"
                                :page.sync="lstmdQueryParams.pageNum"
                                :limit.sync="lstmdQueryParams.pageSize"
                                @pagination="getLstmdList"
                        />
                    </el-row>

                    <!--法律维权典型案例与分析-->
                    <el-row v-show="flwqdxalyfxOpen">
                        <!--标题-->
                        <el-row class="right-box-row-title">
                            {{title}}
                        </el-row>
                        <!--表格-->
                        <el-table v-loading="flwqdxalyfxLoading" :data="flwqdxalyfxList" :show-header="false"
                                  tooltip-effect="light" :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
                            <el-table-column align="left" :show-overflow-tooltip="true" prop="title" class-name="title">
                                <template slot-scope="scope">
                                    <i class="el-icon-menu" style="margin-right: 0.625rem;"></i>
                                    <el-link style="color: #1e6abc" :underline="false" @click="openPage(scope.row)">{{
                                        scope.row.title }}
                                    </el-link>
                                </template>
                            </el-table-column>
                            <el-table-column align="left" :show-overflow-tooltip="true" prop="publicType"
                                             class-name="publicType">
                                <template slot-scope="scope">
                                    <span style="">(案例类型){{publicTypesFormat(scope.row.publicType)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="fbTime" :width="180">
                                <template slot-scope="scope">
                                    <span>{{ parseTime(scope.row.fbTime, '{y}-{m}-{d}') }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!--下一页-->
                        <pagination
                                v-show="flwqdxalyfxTotal>0"
                                :total="flwqdxalyfxTotal"
                                :page.sync="flwqdxalyfxQueryParams.pageNum"
                                :limit.sync="flwqdxalyfxQueryParams.pageSize"
                                @pagination="getFlwqdxalyfxList"
                        />
                    </el-row>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {listFlwqdxalyfxTzgg} from "@/api/xwqy/fvwqdxalyfxTzgg";
    import {updatePvNum} from "@/api/itempv/pv";
    import {listLstmd,} from "@/api/xwqy/lawyers";
    import flfwtgzgz from "./flfwtgzgz";

    export default {
        name: "flwqdxalyfx",
        components:{
            flfwtgzgz
        },
        data() {
            return {
                title:'律师服务团工作规则',
                // 遮罩层
                flwqdxalyfxLoading: false,
                lstmdLoading: false,
                // 总条数
                flwqdxalyfxTotal: 0,
                lstmdTotal: 0,
                flwqdxalyfxList: [],
                lstmdList: [],
                flwqdxalyfxQueryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    modeType: 'fl',
                    bussType: 'zscq',
                    areaCode: 'cn',
                    fbBeginDate: undefined,
                    fbEndDate: undefined,
                    ssBeginDate: undefined,
                    ssEndDate: undefined,
                    orderBy: "zhpx",
                    isAsc: "asc",
                    publicType: undefined,
                },
                lstmdQueryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    lawyer: undefined,
                    lawOffice: undefined,
                    jurisdiction: undefined,
                    tel: undefined,
                    specializedSill: undefined,
                    deptCode: undefined,
                    deptId: undefined,
                    ywAuditStatus: undefined,
                    ywSaveStatus: undefined,
                    ywDelStatus: undefined
                },
                publicTypeOptions: [],
                menuIcon: 'menu-icon',
                menuIconDown: 'menu-icon-down',
                flfwtgzgzOpen: true,
                lstmdOpen: false,
                flwqdxalyfxOpen: false,
                isLoginState:undefined,
            }
        },
        created() {
            this.getDicts("yw_xwqy_flwqdxalyfxlx_type").then(response => {
                this.publicTypeOptions = response.data;
            })
            this.getFlwqdxalyfxList();
            // this.getLstmdList();
            updatePvNum("xwqycz_flwqdxalyfx").then(response => {
                //pv 点击法律维权典型案例与分析
            });
        },
        methods: {
            changeMenu(name, code, url) {
                if (code === '0101') {
                    this.title = name;
                    this.flfwtgzgzOpen = true;
                    this.lstmdOpen = false;
                    this.flwqdxalyfxOpen = false;
                } else if (code === '0201') {
                    // console.log(code)
                    this.title = name;
                    this.flfwtgzgzOpen = false;
                    this.lstmdOpen = true;
                    this.flwqdxalyfxOpen = false;
                    this.getLstmdList()
                } else if (code === '0301') {
                    this.title = name;
                    this.flfwtgzgzOpen = false;
                    this.lstmdOpen = false;
                    this.flwqdxalyfxOpen = true;
                    this.getFlwqdxalyfxList()
                }
            },
            toPage(url) {
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh() {
                this.getFlwqdxalyfxList();
            },
            publicTypesFormat(value) {
                return this.selectDictLabel(this.publicTypeOptions, value);
            },
            //查询律师团名单
            getLstmdList() {
				//----【】需要修改为recid
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (ssessionLoginUser != null && ssessionLoginUser.islogin) {
					this.isLoginState = true;
				} else {
					this.isLoginState = false;
				}
                this.lstmdLoading = true;
                listLstmd(this.lstmdQueryParams).then(response => {
                        this.lstmdList = response.rows;
                        this.lstmdTotal = response.total;
                        this.lstmdLoading = false;
                    }
                );
            },
            //查询法律维权典型案例与分析
            getFlwqdxalyfxList() {
                this.flwqdxalyfxLoading = true;
                listFlwqdxalyfxTzgg(this.flwqdxalyfxQueryParams).then(response => {
                        this.flwqdxalyfxList = response.rows;
                        this.flwqdxalyfxTotal = response.total;
                        this.flwqdxalyfxLoading = false;
                    }
                );
            },
            openPage(item) {
                this.utils.windowOpen('/main/xwqyczfw/flwqdxalyfxDetail/' + item.recid);
            }
        }
    }
</script>

<style scoped>
    .app-container {
        padding: 10px;
        background-color: #ffffff;
    }

    .navigation {
        padding: 20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }

    .left-img img {
        width: 100%;
    }

    .menu-box {
        background-color: #FAFAFA;
        padding: 15px 10px;
    }

    .menu-level1 {
        padding: 10px;
        background-color: #69B1F3;
        padding-left: 20px;
        font-size: 13px;
        text-align: left;
        margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        color: white;
    }

    .menu-level2 {
        padding: 5px 20px 5px 20px;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
    }

    .menu-icon {
        float: right;

    }

    /deep/ .el-menu {
        text-align: left;
        background-color: #FAFAFA;
        border: 0;
    }

    /*
    .menu-box /deep/.el-menu-item.is-active {
        background-color: #EAEAEA;
    }
    */

    .right-box {
        padding-left: 10px;
    }

    .right-box-row {
        border: 1px solid #cccccc;
        padding: 10px 15px;
    }

    .right-box-row-tip {
        padding: 10px;
        background-color: #FBF8E5;
    }

    .right-box-row-title {
        padding: 15px 0;
        text-align: left;
        color: #409eff;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        margin: 10px 0;
    }

    .xqsq {
        min-height: 5rem;
        background-color: #ffaa00;
        color: #FFFFFF;
        font-size: 1.25rem;
        line-height: 5rem;
        border-radius: 0.0625rem;
        cursor: pointer;
    }

    .search-where {
        margin: 10px 0px;
        padding: 15px;
        background-color: #ffffff;
    }

    .search-item {
        display: flex;
        /*border-bottom: 1px solid #000000;*/
    }

    .search-item-left {
        line-height: 40px;
        font-weight: bold;
    }

    .search-item-right {
        flex: 1;
        padding: 0px 10px;
    }

    .el-input {
        width: 600px;
    }
</style>
